// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs-module--root--v9DzF","list":"breadcrumbs-module--list--GHCDD","item":"breadcrumbs-module--item--P8UOc","separator":"breadcrumbs-module--separator--_SzjS"};